import { arrayFromRange } from 'common/helper/array/from-range';
import { GalleryScrollIndicatorComponentStateInterface } from 'common/module/gallery-scroll-indicator/component-state.interface';
import { GalleryScrollIndicatorItemInterface } from 'common/module/gallery-scroll-indicator/item.interface';

/**
 * Creates a list of scroll indicator items based on options
 */
export const galleryScrollIndicatorGetItems = (
  options: GalleryScrollIndicatorComponentStateInterface & {
    /**
     * Active gallery index
     */
    activeIndex: number;

    /**
     * Indicator items count
     */
    itemsCount: number;
    /**
     * Should indicator items be reversed
     */
    isReversed?: boolean;
  }
): GalleryScrollIndicatorItemInterface[] => {
  const result = arrayFromRange(options.itemsCount).map((index) => {
    const item = {
      isActive: false,
      isSmall: false,
      isHidden: false,
    };

    switch (true) {
      case index === options.activeIndex:
        item.isActive = true;
        break;
      case options.lastVisibleItemIndex - options.firstVisibleItemIndex >= options.itemsCount - 1:
        break;
      case index > options.lastVisibleItemIndex:
      case index < options.firstVisibleItemIndex:
        item.isHidden = true;
        break;
      case index === options.lastVisibleItemIndex:
      case index === options.firstVisibleItemIndex:
        item.isSmall = true;
        break;
    }

    return item;
  });

  return options.isReversed ? result.reverse() : result;
};
